import { Box, CircularProgress, Grid } from '@material-ui/core';
import Refunds from 'components/Refunds';
import {
  StyledTab,
  StyledTabs,
  ScrollableBox,
  RefundsContainer,
} from 'containers/AmcDetailsPage/MyRefundsTab/Refunds/styles';
import { StyledtBlocWrapper } from 'containers/AmcDetailsPage/MyRefundsTab/styles';
import useRefunds from 'hooks/amc/useRefunds';
import { isEmpty } from 'lodash';
import React, { useState } from 'react';
import InfiniteScroll from 'react-infinite-scroll-component';
import { injectIntl, IntlShape } from 'react-intl';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { getIsRefundDetailLoadingSelector } from 'store/sinistre/selectors';

function a11yProps(index: number) {
  return {
    id: `my-contracts-tab-${index}`,
    'aria-controls': `my-contracts-tabpanel-${index}`,
  };
}

export interface tabItemProps {
  label: string;
}

const ALL = 'TOUS';

const MyRefunds = ({
  ...props
}: {
  intl: IntlShape;
  getRefundAMCDetails: Function;
  beneficiaries: [];
  isRefundDetailLoading: boolean;
}) => {
  const [expandeds, setExpanded] = useState<boolean | String>(false);
  const [value, setValue] = React.useState(0);
  const {
    data: refunds,
    get,
    loadMore,
    length,
    hasMore,
    loading,
  } = useRefunds();

  const handleChange = (index: String, item: any) => (
    event: React.ChangeEvent<{}>,
    isExpanded: boolean,
  ) => {
    props.getRefundAMCDetails(item);
    setExpanded(isExpanded ? index : false);
  };

  const getTabItems = () =>
    [ALL].concat(
      props.beneficiaries?.map((ele: { member: string }) => ele.member),
    );

  const handleChangeTab = (_: any, newValue: number) => {
    setValue(newValue);
    const tabs = getTabItems();
    const beneficiary = tabs[newValue];
    get(beneficiary !== ALL ? { beneficiary } : {});
  };

  /* istanbul ignore next */
  const onLoadMore = (selectedTab: number) => {
    const tabs = getTabItems();
    const beneficiary = tabs[selectedTab];
    loadMore(beneficiary !== ALL ? { beneficiary } : {});
  };

  return (
    <StyledtBlocWrapper height="auto">
      <StyledTabs
        value={value}
        onChange={handleChangeTab}
        aria-label="my contracts tabs"
        style={{ marginBottom: '20px' }}
      >
        {(getTabItems() as []).map((tab: tabItemProps, index) => (
          <StyledTab
            key={index}
            label={tab}
            {...a11yProps(index)}
            disableRipple
          />
        ))}
      </StyledTabs>
      <ScrollableBox id="scrollableDiv">
        <InfiniteScroll
          scrollableTarget="scrollableDiv"
          dataLength={length}
          next={/* istanbul ignore next */ () => onLoadMore(value)}
          hasMore={hasMore}
          loader={null}
        >
          <RefundsContainer>
            <Refunds
              listIndex={0}
              isLoading={props.isRefundDetailLoading}
              refunds={refunds}
              expanded={expandeds}
              handleChange={(index: String, item: any) =>
                handleChange(index, item)
              }
              showEmptyState={isEmpty(refunds) && !loading}
            />
            {loading && (
              <Box p={2}>
                <Grid justify="center" alignItems="center" container>
                  <CircularProgress data-testid="loader" size={40} />
                </Grid>
              </Box>
            )}
          </RefundsContainer>
        </InfiniteScroll>
      </ScrollableBox>
    </StyledtBlocWrapper>
  );
};

const mapStateToProps = createStructuredSelector<
  any,
  {
    isRefundDetailLoading: false;
  }
>({
  isRefundDetailLoading: getIsRefundDetailLoadingSelector,
});
const mapDispatchToProps = {};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(injectIntl(MyRefunds));
